import React from "react";
import "./Textarea.scss";

import Textarea from "react-textarea-autosize";

const TA = ({
  type,
  label,
  name,
  required,
  value,
  onChange,
  placeholder,
  limit,
  style
}) => (
  <div className="Textarea">
    <label htmlFor={name}>{label}</label>
    <Textarea
      data-limit={limit}
      minRows={3}
      value={value}
      onChange={onChange}
      name={name}
      id={name}
      required={required}
      placeholder={placeholder}
      style={style}
    />
    {limit && (
      <div className="limit" data-limit={value.length === limit ? true : false}>
        {value.length}/{limit}
      </div>
    )}
  </div>
);

export default TA;
